import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import { useConfig } from '../../Hooks/useConfig';

/**
 * Playground homepage (`/`) is the only indexable URL.
 * Every other route (and the entire panel host) is noindex,nofollow.
 */
const SeoRobots = () => {
  const { pathname } = useLocation();
  const { panelUrl } = useConfig();

  const isPlaygroundHost = !panelUrl?.includes(window.location.hostname);
  const isPlaygroundHome =
    isPlaygroundHost && (pathname === '/' || pathname === '');

  return (
    <Helmet>
      <meta
        name="robots"
        content={isPlaygroundHome ? 'index,follow' : 'noindex,nofollow'}
      />
    </Helmet>
  );
};

export default SeoRobots;
